import { createContext, useContext } from "react";

import type {
	Account,
	DiscordCallback,
	DiscordSignInResult,
} from "../account-session/AccountSession.ts";

export interface UserContextType {
	user: Account | null;
	loading: boolean;
	logout: () => Promise<void>;
	fetchProfile: () => Promise<boolean>;
	beginDiscordSignIn: (returnTo?: string) => Promise<string>;
	completeDiscordSignIn: (
		callback: DiscordCallback,
	) => Promise<DiscordSignInResult>;
	cancelDiscordSignIn: () => void;
}

export const UserContext = createContext<UserContextType | undefined>(undefined);

export const useAuth = (): UserContextType => {
	const context = useContext(UserContext);
	if (!context) {
		throw new Error("useAuth must be used within a UserProvider");
	}
	return context;
};
